import { useEffect, useState } from 'react';
import './Button_2.scss'
import { FaAngleRight } from 'react-icons/fa';

type MyButtonProps = {
    OnClick: (open: boolean) => void;
    text: string;
    color: string;
    width: string;
    isBold?: boolean
}

const Button2 = ({ OnClick, text, color, width, isBold = false }: MyButtonProps) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            import('bootstrap/dist/css/bootstrap.min.css');
        }
    }, []);

    const handleClick = () => {
        setIsClicked(!isClicked);
        OnClick(!isClicked);
    }

    return (
        <div className='button-2-container'>
            <div className='button-2' onClick={handleClick} style={{color: color, width: width, ['--border-color' as any]: color}}>
                <span>{text}</span>
                <span className='button-2-arrow'><FaAngleRight /></span>
            </div>
        </div>
    );
}

export default Button2;